import React from 'react';
import { SurveyHeading } from './survey/SurveyHeading';
import { SurveyText } from './survey/SurveyText';
import { SurveyCheckbox } from './survey/SurveyCheckbox';
import { SurveyDropdown } from './survey/SurveyDropdown';
import { SurveyShortAnswer } from './survey/SurveyShortAnswer';
import { SurveyLongAnswer } from './survey/SurveyLongAnswer';

export const VoteSurvey = ({ options, hasVoted, onOptionsUpdate }) => {
    const onOptionUpdated = (surveyOptionId, textValue) => {
        // Ensure int
        surveyOptionId = parseInt(surveyOptionId)

        // Clone the array
        const surveyOptions = [...options]

        // Clone and update each one (only 1 can be ticked)
        for (let i = 0; i < surveyOptions.length; i++) {
            surveyOptions[i] = { ...surveyOptions[i] }
            if (surveyOptions[i].ballotOptionId === surveyOptionId) {
                surveyOptions[i].textValue = textValue
            }
        }

        // Update linked options
        updateLinkedSurveyOptions(surveyOptions)

        // Notify update
        onOptionsUpdate(surveyOptions)
    }

    const updateLinkedSurveyOptions = (surveyOptions) => {
        // Loop over all options to check their linked option text values
        for (let i = 0; i < surveyOptions.length; i++) {
            // Does survey option have a linked ID?
            if (surveyOptions[i].surveyLinkedId != null) {
                for (let k = 0; k < surveyOptions.length; k++) {
                    // Find the linked survey option
                    if (surveyOptions[i].surveyLinkedId === surveyOptions[k].ballotOptionId) {
                        surveyOptions[i].isOptionHidden = !surveyOptions[i].surveyLinkedValues.includes(surveyOptions[k].textValue)
                    }
                }
            }
            else {
                surveyOptions[i].isOptionHidden = false
            }
        }
    }

    return (
        <React.Fragment>
            {options.map((option) =>
                <React.Fragment key={option.ballotOptionId}>
                    {option.isOptionHidden !== true && <div className={'mb-2 py-2 ' + (option.isError ? "-mx-2 p-2 shadow-lg bg-red-100" : "")}>
                        {option.surveyType === "Heading" &&
                            <SurveyHeading option={option} />}
                        {option.surveyType === "Text" &&
                            <SurveyText option={option} />}
                        {option.surveyType === "Checkbox" &&
                            <SurveyCheckbox option={option}
                                hasVoted={hasVoted}
                                onOptionUpdated={onOptionUpdated} />}
                        {option.surveyType === "Dropdown" &&
                            <SurveyDropdown option={option}
                                hasVoted={hasVoted}
                                onOptionUpdated={onOptionUpdated} />}
                        {option.surveyType === "ShortAnswer" &&
                            <SurveyShortAnswer option={option}
                                hasVoted={hasVoted}
                                onOptionUpdated={onOptionUpdated} />}
                        {option.surveyType === "LongAnswer" &&
                            <SurveyLongAnswer option={option}
                                hasVoted={hasVoted}
                                onOptionUpdated={onOptionUpdated} />}
                    </div>}
                </React.Fragment>
            )
            }
        </React.Fragment >
    );
}